exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmptyRoutes-98ba1922{padding:30px 40px 40px 40px}@media screen and (max-width: 700px){.EmptyRoutes-98ba1922{padding:20px 10px}}.mainCard-b5ff0b6b{text-align:center;padding:50px 40px 40px 40px}.mainCard-b5ff0b6b a{max-width:200px;display:inline-block}.buildYourRide-e32c44fe{padding-top:35px}.leadText-cf439cd7{max-width:720px;margin:0px auto 40px auto;display:block}\n", ""]);

// Exports
exports.locals = {
	"EmptyRoutes": "EmptyRoutes-98ba1922",
	"mainCard": "mainCard-b5ff0b6b",
	"buildYourRide": "buildYourRide-e32c44fe",
	"leadText": "leadText-cf439cd7"
};